import "./testimonials.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";

const Testimonials = () => {
  return (
    <section className="testimonials">
      <h3>HEAR FROM MOMS</h3>
      <Swiper
        slidesPerView={3}
        spaceBetween={30}
        navigation
        modules={[Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="content">
            <h5>Priya Goswami</h5>
            <p>
              I am into the 20th week of pregnancy and had never practiced yoga
              in my entire life. Preggerz yoga expert has the perfect knowledge
              of pregnancy yoga which can help in making your pregnancy
              comfortable and stress-free. Iam happy with my decision and will
              continue doing yoga after my delivery as well!!
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default Testimonials;
